const pricingData = (state = null, action) => {
  if (action.type === "SET_PRICING_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_PRICING_DATA": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default pricingData;
